import { useNavigate } from "@solidjs/router";
import type { JSX } from "solid-js";

/**
 * Figma tam/app-bar: violet bar, 26 px back or close icon, title Medium 21 centred (300 px).
 * Figma draws it 118 px with a 54 px fake status bar; on the web the bar is 64 px below the
 * safe area. Leading hotspot 72 x 62.
 */
export function AppBar(props: {
  title: string;
  back?: string | (() => void);
  close?: boolean;
  right?: JSX.Element;
}) {
  const navigate = useNavigate();
  const go = () => (typeof props.back === "function" ? props.back() : navigate(props.back ?? "/"));
  return (
    <header
      class="sticky top-0 z-20 shrink-0 bg-violet text-white"
      style={{ "padding-top": "env(safe-area-inset-top)" }}
    >
      <div class="relative h-16 flex items-center justify-center">
        <button
          type="button"
          class="absolute left-0 top-px h-[62px] w-[72px] flex items-center pl-4"
          onClick={go}
          aria-label={props.close ? "Fermer" : "Retour"}
        >
          <img
            src={props.close ? "/icons/close-white-26.svg" : "/icons/back-white-26.svg"}
            width="26"
            height="26"
            alt=""
          />
        </button>
        <span class="w-[300px] max-w-[calc(100%-144px)] truncate text-center text-[21px] font-medium leading-[1.25] tracking-[0.21px]">
          {props.title}
        </span>
        {props.right && <div class="absolute right-2">{props.right}</div>}
      </div>
    </header>
  );
}
